export default "__VITE_ASSET___mq4VmMR__"